import React, { useEffect, useRef } from "react";
import Label from "./Label";

const Checkbox = ({
  label,
  checked = false,
  indeterminate = false,
  disabled = false,
  onChange,
  className = "",
  "data-testid": dataTestId = "checkbox",
}) => {
  const disabledStyles = disabled ? "cursor-not-allowed opacity-70" : "cursor-pointer";
  const inputRef = useRef(null);
  const isActive = checked || indeterminate;

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  const handleChange = (e) => {
    if (indeterminate) {
      onChange(false);
      return;
    }

    onChange(e.target.checked);
  };

  return (
    <Label
      className={`inline-flex items-start gap-3 select-none ${disabledStyles} ${className}`}>
      <span className="relative flex">
        <input
          ref={inputRef}
          data-testid={dataTestId}
          type="checkbox"
          checked={checked}
          aria-checked={indeterminate ? "mixed" : checked}
          onChange={handleChange}
          disabled={disabled}
          className="peer sr-only"
        />
        <span
          className={`h-5 w-5 rounded-md border-2 flex items-center justify-center transition-all duration-200
            ${isActive ? "bg-theme border-theme text-white" : "bg-white dark:bg-darkThemeModalBg border-[#C3CFCA] dark:border-darkThemeBorder text-transparent"}
            ${disabled ? "" : "shadow-appShadow"}
            peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-theme`}
          aria-hidden="true"
        >
          {indeterminate ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              className="h-3.5 w-3.5"
            >
              <path d="M5 10.375c0-.207.168-.375.375-.375h9.25c.207 0 .375.168.375.375v-.75a.375.375 0 0 0-.375-.375h-9.25A.375.375 0 0 0 5 9.625v.75Z" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              className="h-3.5 w-3.5"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 0 1 0 1.414l-7.25 7.25a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L8.75 11.086l6.543-6.543a1 1 0 0 1 1.414 0Z"
                clipRule="evenodd"
              />
            </svg>
          )}
        </span>
      </span>
      {label && (
        <span className="flex flex-col gap-0.5 min-w-0">
          <span className="text-dark-grey dark:text-white text-sm font-semibold leading-5 tracking-[0.021px] min-w-0">
            {label}
          </span>
        </span>
      )}
    </Label>
  );
};

export default Checkbox;
